import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1v1h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v1h1V4a1 1 0 0 1 1-1Z"
      fill="#007AFF"
    />
    <rect x={2.5} y={6.5} width={11} height={11} rx={1.5} stroke="#007AFF" />
  </svg>
);
const Memo = memo(SvgCopy);
export default Memo;
